import { Suspense } from 'react';
import { observer } from 'mobx-react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useParams } from 'react-router-dom';

import { Toast } from '../../components/toast';
import FacilitatorMenu from './facilitator-menu';
import { appStore } from '../../stores/app-store';
import { Spinner } from '../../components/spinner';
import { toastStore } from '../../stores/toast-store';
import { AuthRequired } from '../../components/authentication';
import { FacilitatorProvider } from '../../contexts/facilitator';
import { FacilitatorPage } from '../../components/facilitator/facilitator-page';
import { ErrorBoundaryFallback } from '../../components/error-boundary-fallback';
import { ROLES } from '../../utils/auth-roles';

/**
 * The layout for private pages.
 * @returns
 */
export const FacilitatorLayout = observer(() => {
  const { gameCode, qrPage } = useParams();
  const getStyle = () => {
    const style = toastStore.getStyle();
    return style ? style : 'none';
  };

  document.title = 'Catalyst Portal - Facilitator';

  return (
    <AuthRequired allowedRoles={[ROLES.FACILITATOR_PORTAL]}>
      <ErrorBoundary
        fallbackRender={(props) => (
          <ErrorBoundaryFallback isFacilitator {...props} />
        )}>
        <Suspense fallback={<Spinner />}>
          <FacilitatorProvider gameCode={gameCode!}>
            {appStore.isLoading() && <Spinner />}
            <div className={'layout layout--facilitator'}>
              {!qrPage && <FacilitatorMenu />}
              <div className={'app-main'}>
                <FacilitatorPage>
                  <Outlet />
                </FacilitatorPage>
              </div>
              <Toast
                style={getStyle()}
                show={toastStore.isShow()}
                title={toastStore.getTitle()}>
                {toastStore.getMessage()}
              </Toast>
            </div>
          </FacilitatorProvider>
        </Suspense>
      </ErrorBoundary>
    </AuthRequired>
  );
});

export default FacilitatorLayout;
